module.exports = __webpack_public_path__ + "img/ospi.d9a5c110.png";